import { render, staticRenderFns } from "./ResendInvitationModal.vue?vue&type=template&id=9b0bf580"
import script from "./ResendInvitationModal.vue?vue&type=script&lang=js"
export * from "./ResendInvitationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports